import React from 'react'
import { MyModal } from '~/components/ui/MyModal'
import { toHtml } from '~/utils'

export const ProductDescModal: React.FC<{
  data: string
  visible: boolean
  setVisible: React.Dispatch<React.SetStateAction<boolean>>
  dark?: boolean
  title?: string
}> = ({ data, visible, setVisible, dark = false, title = '作品描述' }) => {
  return (
    <MyModal
      open={visible}
      title={title}
      onCancel={() => setVisible(false)}
      maskStyle={{
        backgroundColor: 'rgba(0,0,0,0.8)',
      }}
      width={704}
      footer={null}
      dark={dark}
    >
      <div
        className="text-neutral-400 text-base"
        dangerouslySetInnerHTML={{
          __html: toHtml(data),
        }}
      ></div>
    </MyModal>
  )
}
